import { TUI_ENGLISH_LANGUAGE_COUNTRIES } from '@taiga-ui/i18n/languages/english';
const TUI_GERMAN_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['Nummer', 'Kartennummer'],
  cardExpiry: ['Gültig bis', 'Ablaufdatum Karte']
};
const TUI_GERMAN_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['Farbe', 'Verlauf'],
  toolbarTools: {
    undo: 'Rückgängig machen',
    redo: 'Wiederholen',
    font: 'Schriftart',
    fontStyle: 'Schriftstil',
    fontSize: 'Schriftgröße',
    bold: 'Fett',
    italic: 'Kursiv',
    underline: 'Unterstrichen',
    strikeThrough: 'Durchgestrichen',
    justify: 'Blocksatz',
    justifyLeft: 'Blocksatz links',
    justifyCenter: 'Blocksatz mittig',
    justifyRight: 'Blocksatz rechts',
    justifyFull: 'Blocksatz',
    list: 'Liste',
    indent: 'Einrücken',
    outdent: 'Ausrücken',
    unorderedList: 'Ungeordnete Liste',
    orderedList: 'Geordnete Liste',
    quote: 'Blockquote',
    foreColor: 'Farbe',
    backColor: 'Hintergrundfarbe',
    hiliteColor: 'Hilite-Farbe',
    clear: 'Löschen',
    link: 'Link',
    attach: 'Datei anhängen',
    tex: 'TeX einfügen',
    code: 'Quelltext',
    image: 'Bild einfügen',
    insertHorizontalRule: 'Horizontale Linie einfügen',
    superscript: 'Hochgestellt',
    subscript: 'Tiefgestellt',
    insertTable: 'Insert table',
    insertGroup: 'Insert group',
    hiliteGroup: 'Hilite group',
    removeGroup: 'Remove group',
    insertAnchor: 'Insert anchor',
    mergeCells: 'Merge cells',
    splitCells: 'Split cells',
    rowsColumnsManaging: 'Managing rows and columns',
    cellColor: 'Cell color',
    setDetails: 'Details',
    removeDetails: 'Remove details'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'anchor'
  },
  editorTableCommands: [['Insert column before', 'Insert column after'], ['Insert row before', 'Insert row after'], ['Delete column', 'Delete row']],
  editorCodeOptions: ['Code in the text', 'Code in block'],
  editorFontOptions: {
    small: 'Small',
    large: 'Large',
    normal: 'Normal',
    title: 'Title',
    subtitle: 'Subtitle'
  }
};
const TUI_GERMAN_LANGUAGE_ADDON_TABLE = {
  showHideText: 'Anzeigen/Ausblenden',
  paginationTexts: {
    pages: 'Seiten',
    linesPerPage: 'Zeilen pro Seite',
    of: 'von'
  }
};
const TUI_GERMAN_LANGUAGE_CORE = {
  months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  close: 'Schließen',
  clear: 'Leeres Feld',
  nothingFoundMessage: 'Keine Ergebnisse',
  defaultErrorMessage: 'Wert ist ungültig',
  spinTexts: ['Zurück', 'Weiter'],
  shortWeekDays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
  // TODO: i18n replace with current language countries list
  countries: TUI_ENGLISH_LANGUAGE_COUNTRIES
};
const TUI_GERMAN_LANGUAGE_KIT = {
  cancel: 'Abbrechen',
  done: 'Fertig',
  more: 'Mehr',
  otherDate: 'Anderes Datum...',
  showAll: 'Show all',
  hide: 'Hide',
  mobileCalendarTexts: ['Tag auswählen', 'Zeitraum auswählen', 'Wählen Sie Tage'],
  range: ['von', 'bis'],
  countTexts: ['Plus', 'Minus'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd.mm.yyyy',
    MDY: 'mm.dd.yyyy',
    YMD: 'yyyy.mm.dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['Passwort anzeigen', 'Passwort ausblenden'],
  copyTexts: ['Kopieren', 'Kopiert'],
  shortCalendarMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  pagination: ['Vorherige Seite', 'Nächste Seite'],
  fileTexts: {
    loadingError: 'Fehler beim Laden',
    preview: 'Vorschau',
    remove: 'Entfernen'
  },
  inputFileTexts: {
    defaultLabelSingle: 'oder einzelne Datei hier ablegen',
    defaultLabelMultiple: 'oder mehrere Dateien hier ablegen',
    defaultLinkSingle: 'Datei auswählen',
    defaultLinkMultiple: 'Dateien auswählen',
    maxSizeRejectionReason: 'Die Dateigröße überschreitet die maximal zulässige Größe von',
    formatRejectionReason: 'Ungültiges Dateiformat',
    drop: 'Datei hier ablegen',
    dropMultiple: 'Dateien hier ablegen'
  },
  multiSelectTexts: {
    all: 'Alles auswählen',
    none: 'Keine auswählen'
  },
  confirm: {
    yes: 'Ja',
    no: 'Nein'
  },
  previewTexts: {
    rotate: 'Rotieren'
  },
  zoomTexts: {
    zoomOut: 'Verkleinern',
    zoomIn: 'Vergrößern',
    reset: 'Zurücksetzen'
  },
  phoneSearch: 'Geben Sie das Land oder den Code ein'
};
const TUI_GERMAN_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_GERMAN_LANGUAGE = {
  name: 'german',
  ...TUI_GERMAN_LANGUAGE_CORE,
  ...TUI_GERMAN_LANGUAGE_KIT,
  ...TUI_GERMAN_LANGUAGE_ADDON_TABLE,
  ...TUI_GERMAN_LANGUAGE_ADDON_COMMERCE,
  ...TUI_GERMAN_LANGUAGE_ADDON_EDITOR,
  ...TUI_GERMAN_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_GERMAN_LANGUAGE, TUI_GERMAN_LANGUAGE_ADDON_COMMERCE, TUI_GERMAN_LANGUAGE_ADDON_EDITOR, TUI_GERMAN_LANGUAGE_ADDON_TABLE, TUI_GERMAN_LANGUAGE_CORE, TUI_GERMAN_LANGUAGE_KIT, TUI_GERMAN_LANGUAGE_LAYOUT };
